export const calendarDateFormat = {
  lastDay : '[Yesterday]',
  sameDay : '[Today]',
  nextDay : '[Tomorrow]',
  lastWeek : '[last] dddd',
  nextWeek : 'dddd',
  sameElse : 'L'
};